import React from 'react';
import DriverNavBar from '../../Components/NavigationBar/DriverNavBar';
import PasswordChange from '../../Components/Common/PasswordChange';
import Box from '@mui/material/Box';


const DriverProfile = () => {
    return (
        <DriverNavBar>
             <Box sx={{ width: '100%' }}>
         <PasswordChange></PasswordChange>
         </Box>
      </DriverNavBar>
      );
};

export default DriverProfile;